import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { useT } from "../data/i18n";

export const NotFound = () => {
  const { t } = useT();
  return (
    <section className="menu-hero">
      <Seo title="Página no encontrada | Yasmina" description="La página que buscas no existe." path="/404" noindex />
      <div className="container">
        <h1>{t("notfound_title")}</h1>
        <p style={{ margin: "16px 0 28px" }}>{t("notfound_lead")}</p>
        <Link to="/" className="btn primary">{t("notfound_btn")}</Link>
      </div>
    </section>
  );
};
